// Split from one 4.6k-line file (Aug 2026). Load order matches the
// original file: every module attaches itself to `global`, so the
// evaluated result is identical.

require('./jquery_ext')
require('./tooltips')
require('./table_filter')
require('./ws')
require('./onload')
require('./overrides')
require('./matches')
require('./statistics')
require('./ajax')
require('./pre_match')
require('./scoresheet')
require('./context')
require('./alerts')
require('./utils')
require('./signature')
require('./signing')
require('./signing_device')
require('./custom_match')
require('./dev_fill')
require('./match_report')
require('./follow_match')
require('./send_documents')
